export default __webpack_public_path__ + "static/demographics5-8348145590b0d6acd54fc69e30327ccb.png";